import comp from '../components/barrel';

const EP = 'users/get-message-preferences';
const EP_ACTIVATE = 'users/activate-message-preference';
const EP_DEACTIVATE = 'users/deactivate-message-preference';

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function formatDdMmmYyyy(iso) {
  if (iso == null || iso === '') return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
}

export default {
  async prepare() {
    const vars = {};
    vars.target_user_uuid = thsPage.vars.target_user_uuid;
    this.recipe.methods.push(await O.mPOST(EP, vars));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const res = data[EP];
    const rows = res && res.data && Array.isArray(res.data) ? res.data : [];
    await this.buildTableHead();
    await this.buildTableBody(rows);
    window.thsSubTab = this;
  },

  async buildTableHead() {
    const tableHead = U.id('messagePrefsTableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    const cols = [
      'Template name',
      'Description',
      'Action',
      'Status',
      'Activated date',
      'Activated by',
      'De-activated date',
      'De-activated by',
    ];

    cols.forEach((label) => {
      const th = headRow.insertCell();
      th.innerHTML = label;
    });
  },

  async buildTableBody(listData) {
    const tbody = U.id('messagePrefsTableBody');
    tbody.innerHTML = '';
    const page = this;

    if (!listData.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = 8;
      cell.innerHTML = 'No message templates found.';
      return;
    }

    for (const row of listData) {
      const tr = tbody.insertRow();

      const nameCell = tr.insertCell();
      nameCell.textContent =
        row.template_name != null && row.template_name !== '' ? row.template_name : '—';

      const descCell = tr.insertCell();
      descCell.textContent = row.description != null && row.description !== '' ? row.description : '—';

      const actionCell = tr.insertCell();
      const tplUuid = row.template_uuid != null ? String(row.template_uuid) : '';
      const allocId = row.alloc_message_template_user_id;
      const showActivate = tplUuid !== '' && (row.active_yn === false || row.active_yn == null);
      const showDeactivate =
        row.active_yn === true && allocId != null && allocId !== '';
      if (showActivate) {
        const btn = U.divAtt('button', 'type', 'button');
        btn.classList.add('btn');
        btn.textContent = 'Activate';
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          page.postPreferenceToggle('activate', {template_uuid: tplUuid});
        });
        actionCell.appendChild(btn);
      } else if (showDeactivate) {
        const btn = U.divAtt('button', 'type', 'button');
        btn.classList.add('btn');
        btn.textContent = 'De-activate';
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          page.postPreferenceToggle('deactivate', {
            alloc_message_template_user_id: allocId,
          });
        });
        actionCell.appendChild(btn);
      } else {
        actionCell.textContent = '—';
      }

      const activeCell = tr.insertCell();
      if (row.active_yn === true) {
        const tag = await comp.statusTag('Active');
        activeCell.appendChild(tag);
      } else if (row.active_yn === false) {
        const tag = await comp.statusTag('Inactive');
        activeCell.appendChild(tag);
      } else {
        activeCell.textContent = '—';
      }

      const allocatedDateCell = tr.insertCell();
      allocatedDateCell.textContent = formatDdMmmYyyy(row.created_date);

      const allocByCell = tr.insertCell();
      allocByCell.textContent =
        row.allocated_by_name != null && row.allocated_by_name !== ''
          ? row.allocated_by_name
          : '—';

      const deActivatedCell = tr.insertCell();
      deActivatedCell.textContent = formatDdMmmYyyy(row.inactive_date);

      const deActivatedByCell = tr.insertCell();
      deActivatedByCell.textContent =
        row.deallocated_by_name != null && row.deallocated_by_name !== ''
          ? row.deallocated_by_name
          : '—';
    }
  },

  /** View User allocation subtab: side nav calls thsSubTab.savePage(html_text). */
  async savePage(targetId) {
    if (typeof targetId === 'string' && /^VUt_/.test(targetId)) {
      await O.changeSubTab(targetId);
    }
  },

  async postPreferenceToggle(mode, opts) {
    opts = opts || {};
    const target_user_uuid = thsPage.vars.target_user_uuid;
    if (!target_user_uuid) {
      return;
    }

    let vars;
    const method = mode === 'deactivate' ? EP_DEACTIVATE : EP_ACTIVATE;

    if (mode === 'deactivate') {
      const alloc_message_template_user_id = opts.alloc_message_template_user_id;
      if (alloc_message_template_user_id == null || alloc_message_template_user_id === '') {
        return;
      }
      vars = {target_user_uuid, alloc_message_template_user_id};
    } else {
      const template_uuid = opts.template_uuid;
      if (!template_uuid) {
        return;
      }
      vars = {target_user_uuid, template_uuid};
    }

    O.PREP([await O.mPOST(method, vars)])
      .then(async (res) => {
        const payload = res[method];
        const status = payload && payload.status != null ? String(payload.status) : '';
        if (status.toUpperCase() === 'OK') {
          comp.toast(status);
          const refresh = await O.PREP([await O.mPOST(EP, {target_user_uuid})]);
          await this.loadPage(refresh);
        }
      })
      .catch(() => {});
  },
};
